import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { MenuItem } from 'primeng/api';
import { UserManagementMainComponent } from '../user-management-main/user-management-main.component';
import { RolesManagementMainComponent } from '../roles-management-main/roles-management-main.component';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
@Component({
    standalone: true,
    selector: 'app-account-management-main',
    templateUrl: './account-management-main.component.html',
    styleUrls: ['./account-management-main.component.scss'],
    imports: [UserManagementMainComponent, RolesManagementMainComponent, MatTabsModule, PageHeaderComponent, CommonModule]
})
export class AccountManagementMainComponent implements OnInit {
  items: MenuItem[] = [];
  pageTitle = 'User Accounts and Roles';
  pageSubTitle = 'Manage User Accounts and Roles';
  totalRecords = 2;
  selectedTabIndex = 0; // Default tab (Users)

  constructor() {

  }
  ngOnInit(): void {
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
  }
}
